"use client";
import {
  buttonVariants
} from "./chunk-24TR2GH3.js";

// src/pagination.tsx
import { cn } from "@momo/utils";
import { ChevronLeftIcon, ChevronRightIcon, MoreHorizontalIcon } from "lucide-react";
import Link from "next/link";
import { jsx, jsxs } from "react/jsx-runtime";
var Pagination = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "nav",
    {
      role: "navigation",
      "aria-label": "pagination",
      className: cn("mx-auto flex w-full justify-center", className),
      ...rest
    }
  );
};
var PaginationContent = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("ul", { className: cn("flex flex-row items-center gap-1", className), ...rest });
};
var PaginationItem = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("li", { className: cn(className), ...rest });
};
var PaginationLink = (props) => {
  const { className, isActive, size = "icon", ...rest } = props;
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content -- it's a component
    /* @__PURE__ */ jsx(
      Link,
      {
        "aria-current": isActive ? "page" : void 0,
        className: cn(
          buttonVariants({
            variant: isActive ? "outline" : "ghost",
            size
          }),
          className
        ),
        ...rest
      }
    )
  );
};
var PaginationPrevious = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(PaginationLink, { size: "default", className: cn("gap-1 pl-2.5", className), ...rest, children: [
    /* @__PURE__ */ jsx(ChevronLeftIcon, { className: "size-4" }),
    /* @__PURE__ */ jsx("span", { children: "Previous" })
  ] });
};
var PaginationNext = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(PaginationLink, { size: "default", className: cn("gap-1 pr-2.5", className), ...rest, children: [
    /* @__PURE__ */ jsx("span", { children: "Next" }),
    /* @__PURE__ */ jsx(ChevronRightIcon, { className: "size-4" })
  ] });
};
var PaginationEllipsis = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs("span", { className: cn("flex size-9 items-center justify-center", className), ...rest, children: [
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: "More pages" }),
    /* @__PURE__ */ jsx(MoreHorizontalIcon, { className: "size-4", "aria-hidden": "true" })
  ] });
};

export {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationPrevious,
  PaginationNext,
  PaginationEllipsis
};
